import i18n from "@/i18n";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { IoMdArrowRoundBack, IoMdArrowRoundForward, IoMdClose } from "react-icons/io";
import { FaCalendarAlt, FaChevronDown, FaEye } from "react-icons/fa";
import { DateRange } from "react-day-picker";
import { Calendar } from "@/components/ui/calendar";
import { format } from "date-fns";
import axios from "axios";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import PaginationControls from "@/components/PaginationControls";
import { Link } from "react-router-dom";

type Order = {
    _id: string;
    orderId: string;
    deliveryType: string;
    time: number;
    progress: string;
    items: {
        nameAR: string;
        nameEN: string;
        quantity: number;
        addons: {
            nameAR: string;
            nameEN: string;
            price: number;
            totalPrice: number;
        }[];
        options: {
            options: {
                nameAR: string;
                nameEN: string;
            }[]
        }[]
    }[];
};

export default function ChefsOrdersHistory() {
    const { t } = useTranslation();
    const [date, setDate] = useState<DateRange | undefined>({
        from: undefined, // Default start date
        to: undefined, // Default end date (20 days after 2025-01-20)
    });

    const lang = i18n.language;
    const baseUrl = import.meta.env.VITE_BASE_URL
    const token = useSelector((state: { auth: { token: string } }) => state.auth.token);
    const [orders, setOrders] = useState<Order[]>([]);
    const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);
    const [pageNum, setPageNum] = useState(10)
    const [totalItems, setTotalItems] = useState(0)
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const dateListRef = useRef<HTMLDivElement>(null)
    const [selectedTimeStart, setSelectedTimeStart] = useState<number | null>();
    const [selectedTimeEnd, setSelectedTimeEnd] = useState<number | null>();
    const [chartDay, setChartDay] = useState<number | null>(null)
    const [lastMonth, setLastMonth] = useState<number | null>(null)
    const [currentDayStart, setCurrentDayStart] = useState<number | null>(null)
    const [currentDayEnd, setCurrentDayEnd] = useState<number | null>(null)
    // const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(true)
    const fetchedPage = useRef<number | null>(null);
    const containerRef = useRef<HTMLDivElement>(null)
    const dateContainerRef = useRef<HTMLDivElement>(null);
    const [dateOpen, setDateOpen] = useState(false);


    console.log(setLastMonth, setChartDay, selectedTimeStart, selectedTimeEnd)

    function closeDateList() {
        if (dateOpen && dateContainerRef.current) {
            dateContainerRef.current.classList.add("hidden");
            dateContainerRef.current.classList.remove("flex");
            setDateOpen(false);
        }
    }
    // Close when clicking outside
 

      const handleClickOutside = (event: MouseEvent) => {
    if (
      containerRef.current &&
      !containerRef.current.contains(event.target as Node)
    ) {
      closeDateList();
    }
  };
    useEffect(() => {
        if (dateOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // eslint-disable-next-line
    }, [dateOpen]);



    const dateToUnix = (date: Date) => {
        return Math.floor(date.getTime() / 1000); // Convert Date to Unix timestamp (seconds)
    };



    function getCurrentMonthUnixTimestamps() {
        const now = new Date();

        // Get the 1st day of the current month
        const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);

        // Get the last day of the current month
        const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0); // Day 0 of next month = last day of this month

        // Convert to UNIX timestamps (in seconds)
        setCurrentDayStart(Math.floor(startOfMonth.getTime() / 1000));
        setCurrentDayEnd(Math.floor(endOfMonth.getTime() / 1000));
    }
    const formatRange = () => {
        if (date?.from && date?.to) {
            const fromFormatted = format(date.from, "M/d/yyyy");
            const toFormatted = format(date.to, "M/d/yyyy");
            if (fromFormatted === toFormatted) {
                return fromFormatted; // Just one date shown
            }
            return `${fromFormatted} - ${toFormatted}`;
        }

        const today = new Date();
        return format(today, "M/d/yyyy");
    };

    useEffect(() => {
        const from = date?.from;
        const to = date?.to;
        if (from && to) {
            const startUnix = dateToUnix(from);
            const endUnix = dateToUnix(to);

            setSelectedTimeStart(startUnix);
            setSelectedTimeEnd(endUnix);

            getOrderHistory({ start: startUnix, end: endUnix, page: currentPage });
            closeCalendar();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [date?.from, date?.to, currentPage]);

    // defaukt months 
    // useEffect(() => {
    //     if (currentMonthStart && currentMonthEnd) {
    //         setDate({
    //             from: new Date(currentMonthStart * 1000),
    //             to: new Date(currentMonthEnd * 1000),
    //         });
    //     }
    // }, [currentMonthStart, currentMonthEnd]);

    useEffect(() => {
        getCurrentMonthUnixTimestamps();
    }, []);
    //appear the perv month and  the current month 
    // const getPreviousMonth = () => {
    //     const now = new Date();
    //     return new Date(now.getFullYear(), now.getMonth() - 1)
    // };

    const formatUnixTimestamp = (unixTimestamp: number | null): string => {
        if (unixTimestamp === null) {
            return "Invalid date"
        }
        const date = new Date(unixTimestamp * 1000);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }
    const closeCalendar = () => {
        if (dateOpen && dateListRef.current) {
            dateListRef.current.classList.add("hidden");
            dateListRef.current.classList.remove("flex");
            setDateOpen(false);
        }
    };
 


    async function getOrderHistory({ start, end, page }: { start: number; end: number, page: number }) {
        setLoading(true)

        try {
            const response = await axios.get(`${baseUrl}/api/dashboard/orders/history`, {
                params: {
                    page,
                    startTime: formatUnixTimestamp(start),
                    endTime: formatUnixTimestamp(end),
                },
                headers: {
                    Authorization: token,
                }
            })
            if (response?.data?.success) {
                setOrders(response.data.orders);
                setTotalItems(response.data.pagination.totalItems);
                setTotalPages(response.data.pagination.totalPages);
                setSelectedTimeStart(start);
                setSelectedTimeEnd(end);
            }
        } catch (error) {
            console.error(error);
            toast.error(t("chefsHistory.chefsHistoryError"))
        } finally {
            dateListRef.current?.classList.add('hidden');
            dateListRef.current?.classList.remove('flex');
            setDateOpen(false);
            setLoading(false);
            closeCalendar();

        }
    }

    // with month
    // useEffect(() => {
    //     const now = new Date();
    //     const start = startOfMonth(now);
    //     const end = endOfMonth(now);
    //     setDate({ from: start, to: end });
    // }, []);

    useEffect(() => {
        const today = new Date();
        setDate({ from: today, to: today });
    }, []);

    useEffect(() => {
        if (
            chartDay &&
            lastMonth &&
            currentDayStart &&
            currentDayEnd &&
            currentPage !== fetchedPage.current
        ) {
            fetchedPage.current = currentPage;
            getOrderHistory({
                start: currentDayStart,
                end: currentDayEnd,
                page: currentPage,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chartDay, lastMonth, currentDayStart, currentDayEnd, currentPage]);


    function formatJoinTime(joinTime: number | string): string {
        if (!joinTime) return "N/A";

        const timestamp = typeof joinTime === "string" ? parseInt(joinTime, 10) : joinTime;
        const date = new Date(timestamp * 1000);

        const lang = i18n.language?.startsWith("ar") ? "ar" : "en-GB";

        const formattedDate = date.toLocaleDateString(lang, {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });

        const formattedTime = date.toLocaleTimeString('en', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        });

        return `${formattedDate} ,  ${formattedTime}`;
    }



    const openDayList = () => {
        if (!dateOpen) {
            setDate({ from: undefined, to: undefined });
            if (dateListRef.current) {
                dateListRef.current.classList.remove("hidden");
                dateListRef.current.classList.add("flex");
                setDateOpen(true);
            }
        }
    };

    return (
        <div className="overflow-x-visible whitespace-normal">
            <Link
                to="/chefs-orders"
                className="flex size-fit items-center gap-2 rounded-md p-2 duration-150 mb-5 hover:bg-black/10"
            >

                {i18n.language === "ar" ? (
                    <IoMdArrowRoundForward size={26} />
                ) : (
                    <IoMdArrowRoundBack size={26} />
                )}
            </Link>
            <div ref={containerRef} className="relative inline-block text-right mb-5">
                <div
                    className="border px-3 py-2 rounded-md cursor-pointer flex items-center gap-2 "
                    onClick={openDayList}

                >

                    <FaCalendarAlt />
                    <span className="text-sm">{t("chefsHistory.dateRange")}:</span>
                    <span className="text-sm text-gray-600">{formatRange()}</span>
                    <FaChevronDown className="text-sm text-slate-400" />

                </div>
                <h1 className="flex items-center gap-2 mt-4 font-semibold text-slate-500">
                    {t("chefsHistory.dateRange")}
                    <span dir="ltr">({totalItems})</span>
                </h1>

                <div className="absolute z-20 mt-2 bg-white shadow-md rounded-md flex" dir={i18n.language === "ar" ? "rtl" : "ltr"}>
                    <div
                        className={`w-fit bg-white z-50 h-fit flex md:absolute ${lang === "en" ? "left-0" : "right-0"}`}


                    >
                        <div ref={dateListRef} className="z-50 border rounded-md hidden"
                        >
                            <Calendar
                                initialFocus
                                toYear={new Date().getFullYear()}
                                mode="range"
                                selected={date} // Set the selected dates
                                onSelect={setDate} // Update the 'date' state when the user selects a range
                                numberOfMonths={1}
                                disabled={{ after: new Date() }}
                                // defaultMonth={getPreviousMonth()}
                                className="border p-3 rounded-lg bg-white dark:bg-white text-black" // Ensure light mode styles
                                classNames={{
                                    day_range_start: "bg-sidebar rounded-none text-skyblue hover:text-white hover:bg-sidebar",
                                    day_range_end: "bg-sidebar rounded-none text-skyblue hover:text-white hover:bg-sidebar",
                                    day_range_middle: "bg-skyblue rounded-none dark:bg-skyblue text-black hover:text-slate-900 hover:bg-skyblue",
                                    day_selected: "bg-black rounded-none text-black hover:bg-black hover:text-white",
                                    day_today: "border rounded-none border-sidebar text-black hover:text-slate-900 hover:bg-skyblue",
                                    caption: "relative flex items-center justify-center text-base font-semibold text-black",
                                    nav: "absolute inset-0 flex justify-between items-center px-4",
                                    nav_button_previous: "bg-white dark:bg-white  border-0",
                                    nav_button_next: "bg-white dark:bg-white border-0",
                                }}
                                dir={lang === "ar" ? "rtl" : "ltr"}
                            />
                        </div>
                    </div>
                </div>

            </div>
            <div className=" overflow-x-auto whitespace-nowrap text-center">
                {orders.length === 0 ? (
                    <div className="bg-cyan-100 text-center p-6 rounded-lg">
                        <h2 className="text-lg font-semibold text-gray-800">
                            {t("chefsHistory.noOrdersTitle")}
                        </h2>
                        <p className="text-sm text-gray-700 mt-2">
                            {t("chefsHistory.noOrdersMessage")}
                        </p>
                    </div>
                )
                    : (
                        <table className="w-full text-sm  text-gray-500 bg-white">
                            <thead className="text-xs text-gray-700 uppercase bg-white">
                                <tr className="border-b">
                                    <th className="table-cell px-6 py-3">{t("chefsHistory.orderNumber")}</th>
                                    <th className="table-cell px-6 py-3">{t("chefsHistory.orderType")}</th>
                                    <th className="table-cell px-6 py-3">{t("chefsHistory.orderedTime")}</th>
                                    <th className="table-cell px-6 py-3">{t("chefsHistory.invoiceStatus")}</th>
                                    <th className="table-cell px-6 py-3">{t("chefsHistory.actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    [...Array(pageNum)].map((_, index) => (
                                        <tr key={index} className="animate-pulse border-b">
                                            <td className="px-2 py-4  md:flex flex-col gap-2">
                                                <div className="h-4 bg-gray-200 rounded w-24"></div>
                                                <div className="h-3 bg-gray-200 rounded w-16"></div>
                                            </td>
                                            <td className=" px-2 py-3 block md:table-cell">
                                                <div className="h-4 bg-gray-200 rounded w-20"></div>
                                            </td>
                                            <td className="px-2 py-4">
                                                <div className="h-4 bg-gray-200 rounded w-28"></div>
                                            </td>
                                            <td className="py-4">
                                                <div className="h-4 bg-gray-200 rounded w-24"></div>
                                            </td>
                                            <td className="px-2 py-4">
                                                <div className="h-6 bg-gray-200 rounded w-16"></div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    orders.map((order, index) => (

                                        <tr
                                            key={order._id || index}
                                            className="border-b hover:bg-gray-100 cursor-pointer"
                                        >

                                            <td className=" px-6 py-4 flex flex-col">
                                                {order?._id}
                                                <span>{t("ordersBody.Order")}# {order.orderId}</span>
                                            </td>
                                            <td className=" mx-auto table-cell px-6 py-4">
                                                <span className="h-full"> {order.deliveryType === "receiving" ? t("chefsHistory.receiving") : order.deliveryType === "cashier" ? t("chefsHistory.cashier") : null}</span>

                                            </td>
                                            <td className="mx-auto table-cell px-6 py-4">
                                                {formatJoinTime(order.time)}
                                            </td>
                                            <td className="px-4 py-4 text-center align-middle">
                                                <div className="inline-flex justify-center items-center">
                                                    <span className="rounded-xl bg-green-600 px-3 py-1 text-white text-xs">
                                                        {t(`chefsHistory.${order.progress}`)}
                                                    </span>
                                                </div>
                                            </td>

                                            <td className="py-4 text-start space-y-2">
                                                <span
                                                    onClick={() => setSelectedOrder(order)}
                                                    className="px-2 py-[2px] rounded-xl w-16 transition-colors duration-200 text-white cursor-pointer text-start hover:bg-blue-700 bg-blue-600 text-[10px] flex justify-center items-center mx-auto gap-1"
                                                >
                                                    {t("chefsHistory.preview")}
                                                    <FaEye className="text-sm" />
                                                </span>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    )}
            </div>
            {
                selectedOrder && (
                    <div
                        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
                        onClick={() => setSelectedOrder(null)}
                    >
                        <div
                            onClick={(e) => e.stopPropagation()}
                            className="z-[9999]  gap-2 flex-col flex md:w-1/2 lg:w-[600px] w-full overflow-auto max-h-[75vh] bg-white text-black rounded-lg p-5"
                            dir={i18n.language === "ar" ? "ltr" : "rtl"}
                        >
                            <div className="flex justify-end">
                                <IoMdClose
                                    onClick={() => setSelectedOrder(null)}
                                    className="text-red-600 text-xl cursor-pointer"
                                />
                            </div>

                            <div className="border p-2 rounded flex justify-between ">

                                <span className=" flex flex-col">
                                    {selectedOrder?._id}
                                    <span >{t("ordersBody.Order")}# {selectedOrder.orderId}</span>
                                </span>
                                <span className="text-gray-500 font-medium">{t("chefsHistory.orderNumber")}</span>
                            </div>
                            {/* Order Details */}
                            <div className="border p-3 rounded space-y-2 text-center">
                                <h2 className="font-bold">{t("chefsHistory.orderDetails")}</h2>

                                {/* Scrollable container */}
                                <div className="">
                                    {selectedOrder?.items.map((item, index) => (
                                        <div
                                            key={index}
                                            className={`flex flex-col gap-1 py-2 ${selectedOrder.items.length - 1 !== index ? "border-b border-gray-300" : ""
                                                }`}
                                        >
                                            <span className="font-bold" dir={i18n.language === "ar" ? "rtl" : "ltr"}>
                                                {i18n.language === "ar" ? item.nameAR : item.nameEN} × {item.quantity}
                                            </span>

                                            {item.addons?.length > 0 && (
                                                <div className="text-gray-600">
                                                    <span className="font-semibold">{t("cashierHistoryModal.addons")}</span>
                                                    <div className="flex flex-col font-normal">
                                                        {item.addons.map((addon, i) => (
                                                            <span key={i}>{addon.nameAR}</span>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}

                                            {item.options?.length > 0 && (
                                                <div className="text-gray-700">
                                                    <span className="font-semibold">{t("cashierHistoryModal.options")}</span>
                                                    <div className="flex flex-col font-normal">
                                                        {item.options.map((opt, i) =>
                                                            opt.options.map((sub, j) => (
                                                                <span key={`${i}-${j}`}>
                                                                    {sub.nameAR}
                                                                </span>
                                                            ))
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>

                        </div>

                    </div>

                )
            }
            {
                orders.length > 0 && (
                    <PaginationControls
                        pageNum={pageNum}
                        setPageNum={setPageNum}
                        totalItems={totalItems}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalPages={totalPages}
                    />
                )
            }

        </div >
    );
}
